/* MENU FIXO   */

this.header = document.querySelector('header'); // ou uma classe ou ID global do cabeçalho
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.mouse_in_menu = false;
      this.menu_opened = false;
      this.menu_attr = '';
      this.querySelectorAll('nav').forEach((nav) => {
        nav.addEventListener('mouseenter', this.mouseEnterMenu.bind(this));
        nav.addEventListener('mouseleave', this.mouseLeaveMenu.bind(this));
      });
      window.addEventListener('forStickyHeader', this.forStickyHeader.bind(this), false);
    }

    forStickyHeader(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Remove a restrição que pode ser específica para a home, aplicando a todos
      if(scrollTop > this.headerBounds.bottom + this.checkVerticalMenuPostion()){
        this.show();
      };
    }

    mouseEnterMenu(){
      this.mouse_in_menu = true;
    }

    mouseLeaveMenu(){
      this.mouse_in_menu = false;
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header'); // Certifique-se de que o ID está correto em todas as páginas
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.headerBounds.bottom + this.checkVerticalMenuPostion()) {
        requestAnimationFrame(this.show.bind(this));
      }
      
      this.currentScrollTop = scrollTop;
    }

    show() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.contains('shopify-section-first-hide') && this.header.classList.remove('shopify-section-first-hide');
    }

    reset() {
      this.menu_opened = false;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    checkVerticalMenuPostion(){
      const menu = this.querySelector('.vertical-menu');
      if(!menu) return 0;
      if(!menu.hasAttribute('data-menu-opened') && !menu.classList.contains('menu-opening')) return 0;
      return menu.querySelector('vertical-menu').offsetHeight;
    }
  }

  customElements.define('sticky-header', StickyHeader);


/* MENU FIXO   */



/*INICIO SCRIPT TABELA DE PARCELAMENTO MODELO 2*/
document.addEventListener( 'DOMContentLoaded', function () {
  
    // Update price if variant changed

    function _updateProductPriceForBillet( currentVariant ) {

        if ( !currentVariant ) {
            return;
        }

        const billet = document.querySelector( '.parcelament' );
        const money = formatMoney( currentVariant.price, window.theme.moneyFormat );

        if ( billet ) {
            billet.textContent = formatMoney( currentVariant.price * 1, window.theme.moneyFormat );
        }

    }


function formatMoney( cents, format ) {
        if ( typeof cents === 'string' ) {
            cents = cents.replace( ',', '' );
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo( value, defaultValue ) {
            return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters( number, precision, thousands, decimal ) {
            precision = defaultTo( precision, 2 );
            thousands = defaultTo( thousands, '.' );
            decimal = defaultTo( decimal, ',' );

            if ( isNaN( number ) || number == null ) {
                return 0;
            }

            number = ( number / 100.0 ).toFixed( precision );
            var parts = number.split( '.' ),
                dollarsAmount = parts[ 0 ].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands ),
                centsAmount = parts[ 1 ] ? decimal + parts[ 1 ] : '';
            return dollarsAmount + centsAmount;
        }

        var value = '';

        switch ( formatString.match( placeholderRegex )[ 1 ] ) {
            case 'amount':
                value = formatWithDelimiters( cents, 2 );
                break;

            case 'amount_no_decimals':
                value = formatWithDelimiters( cents, 0 );
                break;

            case 'amount_with_space_separator':
                value = formatWithDelimiters( cents, 2, ' ', '.' );
                break;

            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters( cents, 0, ',', '.' );
                break;

            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters( cents, 0, ' ' );
                break;

            case 'amount_with_comma_separator':
                value = formatWithDelimiters( cents, 2, '.', ',' );
                break;
        }

        // 	if ( formatString.indexOf( 'with_comma_separator' ) !== -1 ) {
        // 		return formatString.replace( placeholderRegex, value ).replace( ',00', '' );
        // 	} else {
        // 		return formatString.replace( placeholderRegex, value ).replace( '.00', '' );
        // 	}
        return formatString.replace( placeholderRegex, value );
    }


    function getCurrentVariant() {

        const productJsonElement = document.querySelector( '[data-product-json]' ); // If we are using placeholder, there is no JSON so we wrap here!

        if ( productJsonElement ) {
            const jsonData = JSON.parse( productJsonElement.innerHTML );
            const productData = jsonData[ 'product' ];

            productData[ 'variants' ].forEach( function ( variant ) {
                if ( variant[ 'id' ] === jsonData[ 'selected_variant_id' ] ) {
                    currentVariant = variant;
                }
            } );
        }

        return currentVariant;
    }  
  

function _updatePartialPrices ( variant ) {

      if ( !variant ) {
          return;
      }
  
  const preco = variant.price - (variant.price * 0);

    var parcelas = [
  { vezes: 1, times: 1.0000 },
  { vezes: 2, times: 1.0000 },
  { vezes: 3, times: 1.0000 },
  { vezes: 4, times: 1.1087 },
  { vezes: 5, times: 1.1232 }, 
  { vezes: 6, times: 1.1370 },
  { vezes: 7, times: 1.472 },
  { vezes: 8, times: 1.1627 },
  { vezes: 9, times: 1.1774 },
  { vezes: 10, times: 1.1872 },
  { vezes: 11, times: 1.2021 },
  { vezes: 12, times: 1.2167 },
]
  
  function calculo (preco, times, vezes) {
    return ((preco + 0) * times / vezes );
  }
  
  var el_vezes = Array.from($('.vezes'))
  
  parcelas.forEach(function (parcela, position) {
    var calculo_vezes = calculo(preco, parcela.times, parcela.vezes)
    
    calculo_vezes = formatMoney(calculo_vezes, window.theme.moneyFormat);
    calculo_vezes = ( calculo_vezes);
  
    $(el_vezes[parcela.vezes - 1]).html('<span>' + calculo_vezes +  '</span>');
  })
}


    function init() {

        const currentVariant = getCurrentVariant();
        const billetPrice = document.querySelector( '.parcelament' );


        if ( billetPrice ) {
            billetPrice.textContent = formatMoney( currentVariant.price * 1, window.theme.moneyFormat )
        }


        document.addEventListener( 'variant:changed', function ( event ) {
            const variant = event.detail.variant; // Gives you access to the whole variant details
            _updateProductPriceForBillet( variant );
            _updatePartialPrices( variant );
        } );
    }

    init();
  
  
});
/*FINAL SCRIPT TABELA DE PARCELAMENTO MODELO 2*/

/*microfone*/
document.addEventListener('DOMContentLoaded', function() {
      // Verifica se a API Web Speech é suportada pelo navegador
      if (!('webkitSpeechRecognition' in window)) {
          alert('API Web Speech não é suportada pelo seu navegador.');
      } else {
          // Cria uma nova instância de reconhecimento de voz
          const recognition = new webkitSpeechRecognition();
          recognition.lang = 'pt-BR'; // Define o idioma para português do Brasil
          recognition.continuous = false; // Define o reconhecimento contínuo
          recognition.interimResults = false; // Define se os resultados intermediários devem ser retornados

          // Inicia o reconhecimento de voz quando o div é clicado
          document.getElementById('voice-search-button').addEventListener('click', () => {
              const messageElement = document.getElementById('message');
              messageElement.style.display = 'block'; // Mostra a mensagem "Fale alguma coisa"
              recognition.start();
          });

          // Solicita permissão para usar o microfone
          recognition.onstart = () => {
              console.log('Reconhecimento de voz iniciado.');
          };

          // Manipula o evento de resultado
          recognition.onresult = (event) => {
              const transcript = event.results[0][0].transcript;
              const searchQuery = encodeURIComponent(transcript);
              window.location.href = `/search?q=${searchQuery}`;
          };

          // Manipula o evento de erro
          recognition.onerror = (event) => {
              alert('Erro no reconhecimento de voz: ' + event.error);
          };

          // Manipula o evento de término
          recognition.onend = () => {
              const messageElement = document.getElementById('message');
              messageElement.style.display = 'none'; // Esconde a mensagem
              console.log('Reconhecimento de voz encerrado.');
          };
      }
  });